var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.171 17.828a21.257 21.257 0 0 0 15.543.458M18.286 61.714a21.394 21.394 0 0 0-.457-15.588A21.67 21.67 0 0 1 22.4 22.537a21.943 21.943 0 0 1 11.246-5.943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.172 47.406a21.989 21.989 0 0 0 11.29-5.989m0 0a21.623 21.623 0 0 0 4.572-23.589 21.257 21.257 0 0 1-.32-15.542m-4.251 39.131-18.88-18.88M2.286 45.714a21.028 21.028 0 0 1 15.543.503"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat6);
export default __webpack_public_path__ + "static/media/cat-6.181544082d60ad4cf5451e71efd22b5e.svg";
export { ForwardRef as ReactComponent };